import { customCleanEnv, str } from "envalid";

interface Env {
    versionNumber: string;
}

export const env = customCleanEnv(
    import.meta.env,
    {
        VERSION: str({ default: undefined }),
    },
    (inputEnv): Env => ({
        versionNumber:
            import.meta.env.VITE_ENV_TYPE === "production"
                ? (inputEnv.VERSION ?? "production")
                : (import.meta.env.VITE_ENV_TYPE as string),
    }),
);
